[
  {
    "anchor": {
      "after": {
        "glyph": "𠃌"
      }
    },
    "key": "06273c1d-a469-408f-9ed6-a6c5a152651e",
    "order": 13,
    "slug": "level-1/after-𠃌/quiz-not-a-stroke",
    "sourcePath": "@grapheme-slides/levels/simplified/001/017/quiz-001.gen.js",
    "options": [
      {
        "correct": false,
        "glyph": "丨"
      },
      {
        "correct": false,
        "glyph": "𠃊"
      },
      {
        "correct": true,
        "glyph": "十"
      },
      {
        "correct": false,
        "glyph": "丿"
      }
    ],
    "select": "one",
    "title": "Which one of these is not a stroke?"
  },
  {
    "anchor": {
      "after": {
        "glyph": "𠃌"
      }
    },
    "key": "48ba6e73-95aa-4d33-ac7e-9e8da4c3807a",
    "order": 14,
    "slug": "level-1/after-𠃌/quiz-basic-strokes",
    "sourcePath": "@grapheme-slides/levels/simplified/001/017/quiz-002.gen.js",
    "options": [
      {
        "correct": true,
        "glyph": "丨"
      },
      {
        "correct": false,
        "glyph": "𠃊"
      },
      {
        "correct": true,
        "glyph": "一"
      },
      {
        "correct": true,
        "glyph": "丿"
      },
      {
        "correct": false,
        "glyph": "𠃌"
      }
    ],
    "select": "all",
    "title": "Select all the basic strokes."
  },
  {
    "anchor": {
      "after": {
        "glyph": "𠃌"
      }
    },
    "key": "47f418b3-2173-4ac7-9d98-d1c123605a70",
    "order": 15,
    "slug": "level-1/after-𠃌/quiz-compound-strokes",
    "sourcePath": "@grapheme-slides/levels/simplified/001/017/quiz-003.gen.js",
    "options": [
      {
        "correct": true,
        "glyph": "𠃊"
      },
      {
        "correct": false,
        "glyph": "一"
      },
      {
        "correct": true,
        "glyph": "𠃌"
      },
      {
        "correct": false,
        "glyph": "丨"
      },
      {
        "correct": false,
        "glyph": "丿"
      }
    ],
    "select": "all",
    "title": "Select all the compound strokes."
  }
]
